import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';
import AthenaDashboardHome from './athenaDashboardHome';
import { URL, COMPONENT, ATHENA_DASHBOARD_RESOURCES } from './helper';

const AthenaDashboard: React.FC<{}> = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.dashboard}
					path={DASHBOARD_URL[DASHBOARD_RESOURCES.athenaDashboard]}
					component={AthenaDashboardHome}
				/>
				{_map(_values(ATHENA_DASHBOARD_RESOURCES), (subEntity: string) => {
					return (
						<AuthorizedRoute
							configPageName={DASHBOARD_RESOURCES.athenaDashboard}
							configResourceName={ATHENA_DASHBOARD_RESOURCES.REQUEST_LIST}
							// configActionName={GET_ACTION[subEntity]}
							path={URL[subEntity]}
							component={COMPONENT[subEntity]}
						/>
					);
				})}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.athenaDashboard]} />
			</Switch>
		</>
	);
};

export default AthenaDashboard;
